/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSocialMediaRouteImport } from './routes/_authenticated/social-media'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedCacheMetricsRouteImport } from './routes/_authenticated/cache-metrics'
import { Route as AuthenticatedBotRouteImport } from './routes/_authenticated/bot'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTemplatesIndexRouteImport } from './routes/_authenticated/templates/index'
import { Route as AuthenticatedStaffIndexRouteImport } from './routes/_authenticated/staff/index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedPostsIndexRouteImport } from './routes/_authenticated/posts/index'
import { Route as AuthenticatedModerationIndexRouteImport } from './routes/_authenticated/moderation/index'
import { Route as AuthenticatedMemesIndexRouteImport } from './routes/_authenticated/memes/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedTemplatesNewRouteImport } from './routes/_authenticated/templates/new'
import { Route as AuthenticatedTemplatesTemplateIdRouteImport } from './routes/_authenticated/templates/$templateId'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSocialMediaRoute =
  AuthenticatedSocialMediaRouteImport.update({
    id: '/social-media',
    path: '/social-media',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCacheMetricsRoute =
  AuthenticatedCacheMetricsRouteImport.update({
    id: '/cache-metrics',
    path: '/cache-metrics',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBotRoute = AuthenticatedBotRouteImport.update({
  id: '/bot',
  path: '/bot',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTemplatesIndexRoute =
  AuthenticatedTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStaffIndexRoute = AuthenticatedStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPostsIndexRoute = AuthenticatedPostsIndexRouteImport.update({
  id: '/posts/',
  path: '/posts/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedModerationIndexRoute =
  AuthenticatedModerationIndexRouteImport.update({
    id: '/moderation/',
    path: '/moderation/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMemesIndexRoute = AuthenticatedMemesIndexRouteImport.update({
  id: '/memes/',
  path: '/memes/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesNewRoute =
  AuthenticatedTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesTemplateIdRoute =
  AuthenticatedTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/bot': typeof AuthenticatedBotRoute
  '/cache-metrics': typeof AuthenticatedCacheMetricsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/social-media': typeof AuthenticatedSocialMediaRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/templates/new': typeof AuthenticatedTemplatesNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/memes/': typeof AuthenticatedMemesIndexRoute
  '/moderation/': typeof AuthenticatedModerationIndexRoute
  '/posts/': typeof AuthenticatedPostsIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/staff/': typeof AuthenticatedStaffIndexRoute
  '/templates/': typeof AuthenticatedTemplatesIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesByTo {
  '/unauthorized': typeof UnauthorizedRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/bot': typeof AuthenticatedBotRoute
  '/cache-metrics': typeof AuthenticatedCacheMetricsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/social-media': typeof AuthenticatedSocialMediaRoute
  '/': typeof AuthenticatedIndexRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/templates/new': typeof AuthenticatedTemplatesNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/memes': typeof AuthenticatedMemesIndexRoute
  '/moderation': typeof AuthenticatedModerationIndexRoute
  '/posts': typeof AuthenticatedPostsIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/staff': typeof AuthenticatedStaffIndexRoute
  '/templates': typeof AuthenticatedTemplatesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/bot': typeof AuthenticatedBotRoute
  '/_authenticated/cache-metrics': typeof AuthenticatedCacheMetricsRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/social-media': typeof AuthenticatedSocialMediaRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/_authenticated/templates/new': typeof AuthenticatedTemplatesNewRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/memes/': typeof AuthenticatedMemesIndexRoute
  '/_authenticated/moderation/': typeof AuthenticatedModerationIndexRoute
  '/_authenticated/posts/': typeof AuthenticatedPostsIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/staff/': typeof AuthenticatedStaffIndexRoute
  '/_authenticated/templates/': typeof AuthenticatedTemplatesIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/unauthorized'
    | '/forgot-password'
    | '/sign-in'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/bot'
    | '/cache-metrics'
    | '/profile'
    | '/social-media'
    | '/errors/$error'
    | '/templates/$templateId'
    | '/templates/new'
    | '/users/$userId'
    | '/memes/'
    | '/moderation/'
    | '/posts/'
    | '/roles/'
    | '/staff/'
    | '/templates/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/unauthorized'
    | '/forgot-password'
    | '/sign-in'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/bot'
    | '/cache-metrics'
    | '/profile'
    | '/social-media'
    | '/'
    | '/errors/$error'
    | '/templates/$templateId'
    | '/templates/new'
    | '/users/$userId'
    | '/memes'
    | '/moderation'
    | '/posts'
    | '/roles'
    | '/staff'
    | '/templates'
    | '/users'
  id:
    | '__root__'
    | '/_authenticated'
    | '/unauthorized'
    | '/(auth)/forgot-password'
    | '/(auth)/sign-in'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/bot'
    | '/_authenticated/cache-metrics'
    | '/_authenticated/profile'
    | '/_authenticated/social-media'
    | '/_authenticated/'
    | '/_authenticated/errors/$error'
    | '/_authenticated/templates/$templateId'
    | '/_authenticated/templates/new'
    | '/_authenticated/users/$userId'
    | '/_authenticated/memes/'
    | '/_authenticated/moderation/'
    | '/_authenticated/posts/'
    | '/_authenticated/roles/'
    | '/_authenticated/staff/'
    | '/_authenticated/templates/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  UnauthorizedRoute: typeof UnauthorizedRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authSignInRoute: typeof authSignInRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/social-media': {
      id: '/_authenticated/social-media'
      path: '/social-media'
      fullPath: '/social-media'
      preLoaderRoute: typeof AuthenticatedSocialMediaRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cache-metrics': {
      id: '/_authenticated/cache-metrics'
      path: '/cache-metrics'
      fullPath: '/cache-metrics'
      preLoaderRoute: typeof AuthenticatedCacheMetricsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/bot': {
      id: '/_authenticated/bot'
      path: '/bot'
      fullPath: '/bot'
      preLoaderRoute: typeof AuthenticatedBotRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/': {
      id: '/_authenticated/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof AuthenticatedTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/staff/': {
      id: '/_authenticated/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof AuthenticatedStaffIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/posts/': {
      id: '/_authenticated/posts/'
      path: '/posts'
      fullPath: '/posts/'
      preLoaderRoute: typeof AuthenticatedPostsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/moderation/': {
      id: '/_authenticated/moderation/'
      path: '/moderation'
      fullPath: '/moderation/'
      preLoaderRoute: typeof AuthenticatedModerationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/memes/': {
      id: '/_authenticated/memes/'
      path: '/memes'
      fullPath: '/memes/'
      preLoaderRoute: typeof AuthenticatedMemesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/new': {
      id: '/_authenticated/templates/new'
      path: '/templates/new'
      fullPath: '/templates/new'
      preLoaderRoute: typeof AuthenticatedTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/$templateId': {
      id: '/_authenticated/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedBotRoute: typeof AuthenticatedBotRoute
  AuthenticatedCacheMetricsRoute: typeof AuthenticatedCacheMetricsRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSocialMediaRoute: typeof AuthenticatedSocialMediaRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedTemplatesTemplateIdRoute: typeof AuthenticatedTemplatesTemplateIdRoute
  AuthenticatedTemplatesNewRoute: typeof AuthenticatedTemplatesNewRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedMemesIndexRoute: typeof AuthenticatedMemesIndexRoute
  AuthenticatedModerationIndexRoute: typeof AuthenticatedModerationIndexRoute
  AuthenticatedPostsIndexRoute: typeof AuthenticatedPostsIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
  AuthenticatedStaffIndexRoute: typeof AuthenticatedStaffIndexRoute
  AuthenticatedTemplatesIndexRoute: typeof AuthenticatedTemplatesIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedBotRoute: AuthenticatedBotRoute,
  AuthenticatedCacheMetricsRoute: AuthenticatedCacheMetricsRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSocialMediaRoute: AuthenticatedSocialMediaRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedTemplatesTemplateIdRoute: AuthenticatedTemplatesTemplateIdRoute,
  AuthenticatedTemplatesNewRoute: AuthenticatedTemplatesNewRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedMemesIndexRoute: AuthenticatedMemesIndexRoute,
  AuthenticatedModerationIndexRoute: AuthenticatedModerationIndexRoute,
  AuthenticatedPostsIndexRoute: AuthenticatedPostsIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  AuthenticatedStaffIndexRoute: AuthenticatedStaffIndexRoute,
  AuthenticatedTemplatesIndexRoute: AuthenticatedTemplatesIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  UnauthorizedRoute: UnauthorizedRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authSignInRoute: authSignInRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
